export default (data) => {
    const {
        pageSize, // 頁面尺寸：'A5', 'A4'
        pageOrientation, // 紙張方向： 'landscape', 'portrait'
        companyName, // 公司名稱
        voucherDate, // 傳票日期：民國
        voucherType, // 傳票類型：開帳/結帳/調整
        voucherNumber, // 傳票號碼
        voucherStatus, // 傳票狀態：0待辦、1已核准
        editor, // 編輯人
        editTime, // 編輯時間：113-09-10
        approver, // 准許人
        approveTime, // 准許時間：113-09-10
        systemNo, // 來源系統單號
        items, // 項目
        crdTotal, // 借方合計
        debTotal, // 貸方合計
    } = data;

    // 准許人
    let approveText = '---';
    if (voucherStatus === 1) {
        approveText = `${approver} (${approveTime})`;
    }

    // 項目表格
    const itemRows = [];
    if (items) {
        items.forEach((item) => {
            itemRows.push([
                { text: item.accname, border: [true, false, true, false] },
                { text: item.content, border: [true, false, true, false] },
                { text: item.crdAmt, alignment: 'right', border: [true, false, true, false] },
                { text: item.debAmt, alignment: 'right', border: [true, false, true, false] },
            ]);
        });
    }

    // Definition
    const def = {
        pageSize,
        pageOrientation,
        pageMargins: [30, 85, 30, 50],
        defaultStyle: {
            font: 'NotoSansTC',
            fontSize: 9,
        },
        styles: {
            header: {
                fontSize: 13,
                bold: true,
            },
            headerDate: {
                fontSize: 12,
                bold: true,
            },
            voucherItemTable: {
                margin: [0, 7, 0, 7],
            },
        },
        header: [
            {
                text: companyName,
                style: 'header',
                alignment: 'center',
                margin: [30, 15, 30, 0],
            },
            { text: voucherType, style: 'header', alignment: 'center' },
            { text: voucherDate, style: 'headerDate', alignment: 'center' },
            {
                alignment: 'justify',
                margin: [30, 0, 30, 0],
                columns: [
                    { text: `傳票狀態：${voucherStatus}`, alignment: 'left' },
                    { text: `傳票編號：${voucherNumber}`, alignment: 'right' },
                ],
            },
        ],
        content: [
            {
                style: 'voucherItemTable',
                table: {
                    headerRows: 1,
                    widths: [140, '*', 60, 60],
                    body: [
                        [
                            { text: '會計科目', alignment: 'center' },
                            { text: '摘要', alignment: 'center' },
                            { text: '借方金額', alignment: 'center' },
                            { text: '貸方金額', alignment: 'center' },
                        ],
                        ...itemRows,
                        [
                            { text: ' ', border: [true, false, true, false] },
                            { text: ' ', border: [true, false, true, false] },
                            { text: ' ', border: [true, false, true, false] },
                            { text: ' ', border: [true, false, true, false] },
                        ],
                        [
                            { text: '合計', alignment: 'right', colSpan: 2 },
                            {},
                            { text: crdTotal, alignment: 'right' },
                            { text: debTotal, alignment: 'right' },
                        ],
                    ],
                },
            },
        ],
        footer(currentPage, pageCount) {
            return [
                {
                    alignment: 'justify',
                    margin: [30, 5, 30, 0],
                    columns: [
                        { text: `編輯人：${editor} (${editTime})`, alignment: 'left' },
                        { text: `核准人：${approveText}`, alignment: 'right' },
                    ],
                },
                {
                    alignment: 'justify',
                    margin: [30, 0, 30, 0],
                    columns: [
                        { text: `Sokuji系統單號：${systemNo}` },
                        { text: `${currentPage} / ${pageCount}`, alignment: 'right' },
                    ],
                },
            ];
        },
    };

    return def;
};
